/**
 * Small display helpers shared by the version timeline, the version popup, and
 * the members panel.
 */

/** Resolve a version's author to a display name via the team-members list.
 *  Prefers the stored email; falls back to the numeric created_by, then the
 *  raw email, then 'Unknown'. */
export function authorName(version, members) {
  const email = version?.created_by_email || null;
  const uid = version?.created_by;
  const m = (members || []).find((x) => (
    (email && x.email && x.email.toLowerCase() === email.toLowerCase())
    || (uid != null && Number(x.userId) === Number(uid))
  ));
  return (m && m.name) || email || 'Unknown';
}

/** Find a team member by numeric user id. */
export function memberById(id, members) {
  if (id == null) return null;
  return (members || []).find((x) => Number(x.userId) === Number(id)) || null;
}

/** first6…last6 of a hash, for compact display. Copy the FULL hash, not this. */
export function shortHash(hash) {
  if (!hash) return '';
  if (hash.length <= 14) return hash;
  return `${hash.slice(0, 6)}…${hash.slice(-6)}`;
}

/** Compact relative time, e.g. "3d ago". */
export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const secs = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000);
  if (Number.isNaN(secs)) return '';
  if (secs < 60) return 'just now';
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(months / 12)}y ago`;
}
